import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'
import { SubscriptionData } from 'types'

const getSubscriptions = async (): Promise<SubscriptionData[]> => {
	try {
		const { data } = await axios.get<SubscriptionData[]>('/v1/plan/subscriptions')
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getSubscriptions
